export type Predicate<Context> = (context: Context) => boolean;

// Predicate combinators
export function and<Context>(...predicates: Predicate<Context>[]): Predicate<Context> {
  return (context) => predicates.every((predicate) => predicate(context));
}

export function or<Context>(...predicates: Predicate<Context>[]): Predicate<Context> {
  return (context) => predicates.some((predicate) => predicate(context));
}

// Feature flag predicates
export type FlagContext = {
  flagStore: { ready: boolean; flags: Record<string, boolean | undefined> };
};
export function requireFeatureFlag(featureFlag: string): Predicate<FlagContext> {
  return ({ flagStore }) => Boolean(flagStore.ready && flagStore.flags[featureFlag]);
}

export function omitWhenFeatureFlag(featureFlag: string): Predicate<FlagContext> {
  return ({ flagStore }) => Boolean(flagStore.ready && !flagStore.flags[featureFlag]);
}

// Filter visible items
export function predicateFilter<Context, Item extends { predicate?: Predicate<Context> }>(
  items: Item[],
  context: Context,
): Item[] {
  return items.filter(({ predicate }) => !predicate || predicate(context));
}
